import { defineComponent as k, useCssVars as w, ref as n, computed as p, watchEffect as m, openBlock as a, createElementBlock as c, renderSlot as d, createCommentVNode as C, createElementVNode as $, normalizeClass as B } from "vue";
import { useElementSize as L } from "@vueuse/core";
import './assets/index38.css';const V = { class: "SlidingPanel" }, x = 0.7, F = /* @__PURE__ */ k({
  __name: "SlidingPanel",
  props: {
    disableScroll: { type: Boolean }
  },
  setup(E, { expose: b }) {
    w((l) => ({
      "0d084df5": h.value,
      "132b3160": v.value
    }));
    const e = n(null), u = n(null), f = n(null), h = n(""), v = n(""), r = n(0);
    b({
      scrollElementIntoView: W
    });
    const { width: S } = L(e), y = p(() => r.value > 0), P = p(() => {
      var o;
      const l = S.value ?? 0, t = ((o = e.value) == null ? void 0 : o.scrollWidth) ?? 0;
      return r.value + l <= t - 1;
    });
    m(() => {
      var t;
      const { width: l = 0 } = ((t = u.value) == null ? void 0 : t.getBoundingClientRect()) ?? {};
      h.value = `${l}px`;
    }), m(() => {
      var t;
      const { width: l = 0 } = ((t = f.value) == null ? void 0 : t.getBoundingClientRect()) ?? {};
      v.value = `${l}px`;
    });
    function g(l) {
      var s, i;
      const t = ((s = e.value) == null ? void 0 : s.clientWidth) ?? 0, o = l === "left" ? -1 : 1;
      (i = e.value) == null || i.scrollBy({
        left: o * t * x,
        behavior: "smooth"
      });
    }
    function R() {
      var l;
      r.value = ((l = e.value) == null ? void 0 : l.scrollLeft) ?? 0;
    }
    function W(l) {
      var i, _;
      const t = l.offsetLeft, o = l.clientWidth / 2, s = (((i = e.value) == null ? void 0 : i.clientWidth) ?? 0) / 2;
      (_ = e.value) == null || _.scrollTo({
        left: t - s + o,
        // Center the element in the scroll
        behavior: "smooth"
      });
    }
    return (l, t) => (a(), c("div", V, [
      y.value ? (a(), c("button", {
        key: 0,
        ref_key: "leftControlRef",
        ref: u,
        class: "SlidingPanel__control-left",
        "data-cy": "sliding-panel-button-left",
        "aria-label": "Scroll to left",
        tabindex: "-1",
        onClick: t[0] || (t[0] = (o) => g("left"))
      }, [
        d(l.$slots, "button-left")
      ], 512)) : C("", !0),
      $("div", {
        ref_key: "scrollRef",
        ref: e,
        class: B(["SlidingPanel__scroll", { "SlidingPanel__scroll--disabled": l.disableScroll }]),
        onScroll: R
      }, [
        d(l.$slots, "default")
      ], 34),
      P.value ? (a(), c("button", {
        key: 1,
        ref_key: "rightControlRef",
        ref: f,
        class: "SlidingPanel__control-right",
        "data-cy": "sliding-panel-button-right",
        "aria-label": "Scroll to right",
        tabindex: "-1",
        onClick: t[1] || (t[1] = (o) => g("right"))
      }, [
        d(l.$slots, "button-right")
      ], 512)) : C("", !0)
    ]));
  }
});
export {
  F as SlidingPanel
};
